import angular from 'angular';
import productComparisonItem from './productComparisonItem';

export default angular
  .module('loanProductFinder.components.productComparisonItem', [])
  .component('productComparisonItem', productComparisonItem).name;
